export default __webpack_public_path__ + "static/whisky-stock-4ca667100b239b0adf1dbb873ff69c10.jpg";